import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ThongBaoComment} from '../../models/info/thongbaocomment';
const apiUrl = `${environment.apiUrl}/api/info/thongbaocomment`;

@Injectable({
  providedIn: 'root'
})
export class ThongBaoCommentService {
  constructor(public httpService: HttpClient) { }
  public getCountByKeyword(id: number, staffId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?id=${id}&uid=${staffId}`).pipe(
      map(data => Number(data)));
  }
  findAllByPaging(id: number, staffId: number, page: number, size: number): Observable<ThongBaoComment[]> {
    return this.httpService.get<ThongBaoComment[]>(`${apiUrl}/getallpaging?id=${id}&uid=${staffId}&page=${page}&size=${size}`)
      .pipe(map(data => data.map(data => new ThongBaoComment().deserialize(data)))
      );
  }
}
